const communityMenu = [
  {
    id: 1,
    path: '/community/index',
    name: '社区管理',
    meta: {
      title: '社区管理',
      icon: 'personal'
    },
    children: [
      {
        id: 11,
        path: '/community/category',
        name: '板块管理',
        meta: {
          title: '板块管理'
        },
        parent_id: 1
      },
      {
        id: 12,
        path: '/community/tipOffPost',
        meta: {
          title: '举报管理'
        },
        name: '举报管理',
        parent_id: 1
      },
      {
        id: 13,
        path: '/community/content',
        meta: {
          title: '内容管理'
        },
        name: '内容管理',
        parent_id: 1
      },
      {
        id: 14,
        path: '/community/user',
        meta: {
          title: '用户管理'
        },
        name: '用户管理',
        parent_id: 1
      },
      {
        id: 15,
        path: '/community/setting',
        meta: {
          title: '轮播设置'
        },
        name: '轮播设置',
        parent_id: 1
      }
    ]
  },
  {
    id: 2,
    path: '/community/news',
    name: '资讯管理',
    meta: {
      title: '资讯管理',
      icon: 'personal'
    },
    children: [
      {
        id: 21,
        path: '/community/newsType',
        meta: {
          title: '类别管理'
        },
        name: '类别管理',
        parent_id: 2
      },
      {
        id: 22,
        path: '/community/newsContent',
        meta: {
          title: '内容管理'
        },
        name: '内容管理',
        parent_id: 2
      },
      {
        id: 23,
        path: '/community/newsSetting',
        meta: {
          title: '轮播管理'
        },
        name: '轮播管理',
        parent_id: 2
      }
    ]
  },
  {
    id: 3,
    path: '/community/version',
    meta: {
      title: '版本管理',
      icon: 'personal'
    },
    name: '版本管理'
  },
  {
    id: 4,
    path: '/community/appointment',
    name: '预约入园管理',
    meta: {
      title: '预约入园管理',
      icon: 'personal'
    },
    children: [
      {
        id: 41,
        path: '/community/appointment',
        meta: {
          title: '预约信息管理'
        },
        name: '预约信息管理',
        parent_id: 4
      },
      {
        id: 42,
        path: '/community/configuration',
        meta: {
          title: '配置管理'
        },
        name: '配置管理',
        parent_id: 4
      }
    ]
  },
  {
    id: 5,
    path: '/community/back',
    name: '返回业务管理',
    meta: {
      title: '返回业务管理',
      icon: 'personal'
    }
  }
];
export default communityMenu;
